import { createAsyncThunk } from '@reduxjs/toolkit';

import { RegistrationService } from 'api';

import { ResendConfirmationEmailProps } from 'models/form';

import { asyncPayloadCreator } from 'utils';

export const resendConfirmationEmail = createAsyncThunk(
	'registration/resendConfirmationEmail',
	(credentials: ResendConfirmationEmailProps, { rejectWithValue }) =>
		asyncPayloadCreator(
			credentials,
			{ rejectWithValue },
			RegistrationService.resendConfirmationEmail,
		),
);
